import { render, staticRenderFns } from "./ScriptContainer.vue?vue&type=template&id=2bcfa3b0&"
import script from "./ScriptContainer.vue?vue&type=script&lang=ts&"
export * from "./ScriptContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports